module.exports = __webpack_public_path__ + "img/wallis_and_futuna.07fb1b2.webp";